import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { api } from "../../lib/api";
import { CheckCircle2, GraduationCap, Clock, CircleDashed } from "lucide-react";
import ScormPlayer from "./ScormPlayer";

const STATUS_META = {
  completed: { label: "Completed", icon: CheckCircle2, cls: "text-emerald-600 border-emerald-500/40 bg-emerald-500/10" },
  in_progress: { label: "In progress", icon: Clock, cls: "text-amber-600 border-amber-500/40 bg-amber-500/10" },
  not_started: { label: "Not started", icon: CircleDashed, cls: "text-muted-foreground border-border" },
};

export default function PortalTrainings() {
  const [trainings, setTrainings] = useState(null);
  const [playingId, setPlayingId] = useState(null);

  const load = () => api.get("/employee-portal/trainings").then((r) => setTrainings(r.data.trainings));
  useEffect(() => { load(); }, []);

  if (playingId) {
    return <ScormPlayer assignmentId={playingId} onBack={() => { setPlayingId(null); load(); }} />;
  }

  if (!trainings) return <div className="h-40 rounded-xl bg-muted/40 animate-pulse" />;

  return (
    <div className="space-y-4" data-testid="portal-trainings">
      <h1 className="text-xl font-semibold">Trainings</h1>
      <div className="space-y-2">
        {trainings.map((t) => {
          const meta = STATUS_META[t.status] || STATUS_META.not_started;
          const Icon = meta.icon;
          return (
            <Card key={t.id} data-testid={`portal-training-row-${t.id}`}>
              <CardContent className="p-4 flex items-center justify-between gap-3 flex-wrap">
                <div className="flex items-center gap-3 min-w-0">
                  <GraduationCap className="w-4 h-4 text-muted-foreground flex-shrink-0" />
                  <div className="min-w-0">
                    <div className="text-[13px] font-medium">{t.course_title}</div>
                    <div className="text-[11px] text-muted-foreground mt-0.5">
                      {t.due_date ? `Due ${t.due_date}` : "No due date"}
                      {t.score != null ? ` · Score ${t.score}` : ""}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <Badge variant="outline" className={`gap-1 ${meta.cls}`}>
                    <Icon className="w-3 h-3" /> {meta.label}
                  </Badge>
                  <Button
                    size="sm"
                    variant={t.status === "completed" ? "outline" : "default"}
                    onClick={() => setPlayingId(t.id)}
                    data-testid={`portal-training-launch-btn-${t.id}`}
                  >
                    {t.status === "completed" ? "Review" : t.status === "in_progress" ? "Continue" : "Start"}
                  </Button>
                </div>
              </CardContent>
            </Card>
          );
        })}
        {trainings.length === 0 && (
          <div className="text-[12.5px] text-muted-foreground text-center py-10" data-testid="portal-trainings-empty">
            No training courses assigned to you yet.
          </div>
        )}
      </div>
    </div>
  );
}
